const clampPage = (page, lastPage, jumpValue) => {
  if (page > lastPage) {
    return lastPage;
  }
  if (page <= jumpValue) {
    return jumpValue;
  }
  return page;
};

export { clampPage };
